import { takeLatest, call, put } from 'redux-saga/effects'
import UploadFile from 'api/commons/UploadFile'
import * as fromActions from '../../actions/user.action'

const userUpload = (file: File) => UploadFile(file, '/users/imports')

function* userUploadEffectSaga(action: any) {
  try {
    const { data } = yield call(userUpload, action.payload)

    // dispatch action to change redux state
    yield put(fromActions.Actions.userUploadSuccess(data))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* userUploadWatcherSaga() {
  yield takeLatest(fromActions.USER_UPLOAD, userUploadEffectSaga)
}
